import { useContext } from 'react';

import { SectionLoadingSpinnerContext } from '../../contexts';

import { SectionLoadingSpinnerContextInterface } from '../../types/contexts';

export default function useSectionLoadingSpinner(): SectionLoadingSpinnerContextInterface {
  return useContext(SectionLoadingSpinnerContext);
}
